import React from 'react';
import { Card, Progress } from 'antd';
import { Link } from 'react-router-dom';
import { formatCurrency, formatPercentage } from '../../utils/currencyUtils';

interface ProgressItem {
  name: string;
  amount: number;
  percentage: number;
  link?: string;
}

interface ProgressChartProps {
  title: string;
  data: ProgressItem[];
  colors?: string[];
  maxHeight?: string;
}

const ProgressChart: React.FC<ProgressChartProps> = ({ 
  title, 
  data, 
  colors = ['#3B82F6', '#8B5CF6', '#F59E0B', '#10B981', '#EF4444'],
  maxHeight = 'max-h-64'
}) => {
  return (
    <Card title={title} className="h-full">
      <div className={`${maxHeight} overflow-y-auto pr-2 custom-scrollbar`}>
        {data.map((item, index) => (
          <Link 
            key={index} 
            to={item.link || '#'} 
            className="block"
          >
            <div className="mb-4 p-2 rounded hover:bg-gray-50 hover:shadow-sm transition-all duration-200 cursor-pointer border border-transparent hover:border-gray-200">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium">{item.name}</span>
                <span className="text-sm text-gray-600">
                  {formatCurrency(item.amount)}
                </span>
              </div>
              <Progress 
                percent={Math.round(item.percentage)} 
                size="small" 
                strokeColor={colors[index % colors.length]}
                showInfo={false}
              />
              <div className="text-xs text-gray-500 mt-1">
                {formatPercentage(item.percentage)} of total
              </div>
            </div>
          </Link>
        ))}
      </div>
    </Card>
  );
};

export default ProgressChart;
